import { render, staticRenderFns } from "./AccountsReact.vue?vue&type=template&id=6505ec64&"
import script from "./AccountsReact.vue?vue&type=script&lang=js&"
export * from "./AccountsReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports